import { rootApi } from 'root-api'

const recapPermissionsPath = (trackedMeetingUuid) => (
  `/api/notetaker/tracked_meetings/${trackedMeetingUuid}/permissions`
)

const permittedRecapsPath = () => '/api/notetaker/tracked_meetings/permitted_recaps'

const recapPermissionsTag = (trackedMeetingUuid) => ({
  type: 'recapPermissions',
  id: trackedMeetingUuid,
})

const permittedRecapsTag = { type: 'permittedRecaps', id: 'LIST' }

const recapPermissionsRequestOptions = {
  transformRequest: false,
}

const invalidatesRecapPermissions = (_result, error, { meetingUuid }) => (
  error ? [] : [recapPermissionsTag(meetingUuid), permittedRecapsTag]
)

const recapPermissionsApi = rootApi
  .enhanceEndpoints({ addTagTypes: ['recapPermissions', 'permittedRecaps'] })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchRecapPermissions: build.query({
        query: (trackedMeetingUuid) => ({
          url: recapPermissionsPath(trackedMeetingUuid),
        }),
        providesTags: (_result, _error, trackedMeetingUuid) => [
          recapPermissionsTag(trackedMeetingUuid),
        ],
      }),
      postRecapPermissions: build.mutation({
        query: ({ meetingUuid, users, organizations, userGroups, userEmails, skipEmail }) => ({
          url: recapPermissionsPath(meetingUuid),
          method: 'POST',
          data: { users, organizations, userGroups, userEmails },
          ...(skipEmail ? { params: { skip_email: skipEmail } } : {}),
        }),
        extraOptions: recapPermissionsRequestOptions,
        invalidatesTags: invalidatesRecapPermissions,
      }),
      deleteRecapPermissions: build.mutation({
        query: ({ meetingUuid, users, organizations, userGroups, userEmails }) => ({
          url: recapPermissionsPath(meetingUuid),
          method: 'DELETE',
          data: { users, organizations, userGroups, userEmails },
        }),
        extraOptions: recapPermissionsRequestOptions,
        invalidatesTags: invalidatesRecapPermissions,
      }),
      fetchPermittedRecapsForUser: build.query({
        query: () => ({
          url: permittedRecapsPath(),
        }),
        providesTags: [permittedRecapsTag],
      }),
    }),
    overrideExisting: true,
  })

export const {
  useLazyFetchRecapPermissionsQuery,
  usePostRecapPermissionsMutation,
  useDeleteRecapPermissionsMutation,
} = recapPermissionsApi
